export const EXTRA_ORDER = ["flexibleticket", "cabinbag", "checkedbag", "travelinsurance", "cfar", "seats"];
export const FLIGHT_ORDER = ["adult", "child", "infant"];
export const sortItems = (sortArr, items) => {
    return items.sort((a, b) => {
        const idxA = sortArr.findIndex((v) => a.id.includes(v));
        const idxB = sortArr.findIndex((v) => b.id.includes(v));
        if (idxA === -1)
            return 1;
        if (idxB === -1)
            return -1;
        return idxA - idxB;
    });
};
export const sortSectionItems = (id, items) => {
    if (id === "EXTRA") {
        return sortItems(EXTRA_ORDER, items);
    }
    else if (id === "FLIGHT") {
        return sortItems(FLIGHT_ORDER, items);
    }
    else {
        return items.sort((a, b) => a.title.localeCompare(b.title));
    }
};
export const isNegativePrice = (price) => {
    return price.units < 0 || (price.units === 0 && price.nanos < 0);
};
